import { render, staticRenderFns } from "./xizaoka_list.vue?vue&type=template&id=aa3f607a&scoped=true&"
import script from "./xizaoka_list.vue?vue&type=script&lang=js&"
export * from "./xizaoka_list.vue?vue&type=script&lang=js&"
import style0 from "./xizaoka_list.vue?vue&type=style&index=0&id=aa3f607a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3f607a",
  null
  
)

export default component.exports